const navLinks = document.querySelectorAll(".js-menu-link");
const spMenuTrigger = document.querySelector(".js-open-menu");

if (navLinks && spMenuTrigger) {
  const handleNavScroll = () => {
    navLinks.forEach((navItem) => {
      navItem.addEventListener("click", function () {
        spMenuTrigger.checked = false;
      });
    });
  };

  window.addEventListener("load", function () {
    handleNavScroll();
  });
}
